import { query, where, getDocs } from 'firebase/firestore';
import { chunk } from 'shared';

// Firestore's `where('__name__', 'in', ...)` caps at 30 values. This splits
// `ids` into chunks, runs one query per chunk in parallel, and merges the
// results so callers never silently drop or throw past the cap.
export const getDocsByIdsChunked = async (collectionRef, ids) => {
  const uniqueIds = [...new Set(ids)];
  if (uniqueIds.length === 0) {
    return [];
  }

  const snapshots = await Promise.all(
    chunk(uniqueIds, 30).map((batch) =>
      getDocs(query(collectionRef, where('__name__', 'in', batch)))
    )
  );

  return snapshots.flatMap((snapshot) => snapshot.docs);
};
